
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"dialog.title.default":"Generating Data","error.tooManyRows":"Too many rows","warning.manyRows":"Many rows"},"de":{"dialog.title.default":"Daten werden generiert","error.tooManyRows":"Zu viele Zeilen","warning.manyRows":"Sehr viele Zeilen"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();